module.exports = __webpack_public_path__ + "img/Hourglass.cecf0938.svg";